<div>
  @if (loading) {
    <rt-spinner />
  }
  @for (error of errors; track trackByErrorMessage($index, error)) {
    <rt-message variant="context-error" margin-top>
      {{ error }}
    </rt-message>
  }
</div>
